export default function Filter() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12">
      <path
        fill="#FF2D55"
        d="M.091 1.286A.934.934 0 01.937.75h10.127a.94.94 0 01.724 1.533L7.501 7.52v2.98a.749.749 0 01-1.2.6L4.8 9.976a.745.745 0 01-.3-.6V7.52L.21 2.281a.935.935 0 01-.12-.995z"
      />
    </svg>
  )
}
